import {moment} from "@/src/modules/core/lib/moment";
import type {Shift} from "@/src/modules/shifts/types";

/** True once the shift has reached its scheduled (or extended) end. */
export function isShiftPastScheduledEnd(shift: Shift, now: number = Date.now()): boolean {
  const end = shift.extended_end_datetime ?? shift.to_datetime;
  if (!end) {
    return false;
  }
  return moment(end).isSameOrBefore(moment(now));
}

/**
 * Presence of the shift-end gate, computed from fresh shift data.
 */
export function deriveShiftGatePresence(input: {shift: Shift | null; now?: number}): {
  shiftEnd: boolean;
} {
  const {shift, now = Date.now()} = input;
  if (!shift || shift.status !== "active") {
    return {shiftEnd: false};
  }
  return {shiftEnd: isShiftPastScheduledEnd(shift, now)};
}
